import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M2 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm8 3h3.133L15 9.353V13a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2Zm2 1.5h-2a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3H12V8.5ZM4.375 9A4.375 4.375 0 0 0 0 13.375c0 .345.28.625.625.625H6V9H4.375Z';
const draw24px =
  'M5 6.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM16 11h4.6l2.4 3.235V20a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2Zm3 1.5h-3a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-5H19v-2.5ZM7.125 13A6.125 6.125 0 0 0 1 19.125c0 .483.392.875.875.875H12v-7H7.125Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const PersonDocFilledIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'personDocFilled')) as IconWithRender;

PersonDocFilledIcon.displayName = 'PersonDocFilledIcon';
PersonDocFilledIcon.propTypes = Icon.propTypes;
PersonDocFilledIcon.renderIcon = (props) => <PersonDocFilledIcon {...props} />;
export default PersonDocFilledIcon;
